import React from "react"
import {withSnackbar} from "react-simple-snackbar";
import {defaultSnackbarOptions} from "../../../Config";
import {injectIntl} from "react-intl";
import QuickPaymentBase from "./QuickPaymentBase";
class QuickPayment extends QuickPaymentBase {}
export default injectIntl(withSnackbar(QuickPayment, defaultSnackbarOptions))